<main id="page_{{ slug }}">
    @if (!busy) {
        <section>
            <div class="page-title">
                <h1>{{ title }}</h1>
                @if (headerImage) {
                    <img [src]="headerImageSourceUrl" [alt]="title" />
                }
            </div>

            <app-inner-content [content]="content"></app-inner-content>

            @if (childType == 'tabs') {
                <div>
                    <app-tabbed
                        [page]="page"
                        [pages]="children"
                        [selectedIndex]="selectedIndex"
                    ></app-tabbed>
                </div>
            }

            @if (childType === 'cards') {
                <app-cards [pages]="children"></app-cards>
            }

            @if (childType === researchCards) {
                <app-research-cards
                    [pageChildren]="children"
                ></app-research-cards>
            }

            @if (pageData.type === researchCard) {
                <app-user-research-detail
                    [parent]="pageData.parent"
                ></app-user-research-detail>
            }

            @if (type == 'whats-new') {
                <div>
                    <app-whats-new></app-whats-new>
                </div>
            }

            @if (type === 'ui' || type === 'demo' || type === 'custom') {
                <iframe
                    class="externalContent"
                    [src]="safeUrl(iframeUrl)"
                    title="external content"
                ></iframe>
            }
        </section>
    }

    @if (busy) {
        <app-page-blockframe></app-page-blockframe>
    }
</main>

@if (error) {
    <main id="page_{{ slug }}_error">
        <app-error [error]="error"></app-error>
    </main>
}
